export default __webpack_public_path__ + "static/media/horarios-matri.ac537de6.svg";